import {DndContext, closestCenter, PointerSensor, KeyboardSensor, useSensor, useSensors} from "@dnd-kit/core"
import {SortableContext, verticalListSortingStrategy, arrayMove, useSortable} from "@dnd-kit/sortable"
import {CSS} from "@dnd-kit/utilities"
import {Box, Stack} from "@mui/material"
import React from "react"
import {ChevronsUpDown} from "lucide-react"
import {cloneAndReplace} from "../../misc/widget-functions"
import Content from "../../components/Content"

const SortableItem = ({id, children}) => {
    const {attributes, listeners, setNodeRef, transform, transition} = useSortable({id})
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    }
    return (
        <Box ref={setNodeRef} style={style} display="flex" alignItems="center">
            <Box
                {...attributes}
                {...listeners}
                sx={{cursor: "grab", mr: 1, display: "flex", alignItems: "center"}}>
                <ChevronsUpDown size={20} />
            </Box>
            <Box flex={1}>{children}</Box>
        </Box>
    )
}

const ContainerSortableList = ({container, value, onValueChange, disabled}) => {
    const entries = value ?? []
    const isSortable = container.sortable !== false
    const sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor))

    const handleDragEnd = (event) => {
        const {active, over} = event
        if (active.id !== over?.id) {
            const oldIndex = entries.findIndex((e) => e.id === active.id)
            const newIndex = entries.findIndex((e) => e.id === over.id)
            onValueChange(arrayMove(entries, oldIndex, newIndex))
        }
    }

    const renderItems = () =>
        entries.map((entry, index) => {
            const clonedChildren = container.children.map((child) =>
                cloneAndReplace(child, index),
            )
            const content = clonedChildren.map((child) => (
                <Content
                    key={child.id}
                    child={child}
                    disabled={disabled}
                />
            ))

            if (isSortable) {
                return (
                    <SortableItem
                        key={entry.id}
                        id={entry.id}>
                        {content}
                    </SortableItem>
                )
            }
            return <Box key={entry.id}>{content}</Box>
        })

    if (isSortable) {
        return (
            <DndContext
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}
                sensors={sensors}>
                <SortableContext
                    items={entries.map((e) => e.id)}
                    strategy={verticalListSortingStrategy}>
                    <Stack spacing={1}>{renderItems()}</Stack>
                </SortableContext>
            </DndContext>
        )
    }

    return <Stack spacing={1}>{renderItems()}</Stack>
}

export default ContainerSortableList
